<template>
  <svg class="ck-icon" :class="[sizeClass, { 'ck-icon--fill': fill }]" aria-hidden="true" focusable="false">
    <use :href="'#i-' + name" />
  </svg>
</template>

<script>
// A glyph from the Sumi icon set (IconSprite.vue). Decorative by default: a glyph alone needs an aria-label on its link or button.
export default {
  name: 'CkIcon',
  props: {
    name: { type: String, required: true },
    size: { type: String, default: 'md' }, // sm (16) · md (20) · lg (24)
    fill: { type: Boolean, default: false } // a filled mark (brand logos) instead of a stroke glyph
  },
  computed: {
    sizeClass() {
      return this.size === 'sm' ? 'ck-icon--sm' : this.size === 'lg' ? 'ck-icon--lg' : '';
    }
  }
}
</script>
